import { useEffect } from "react";
import HomeBanner from "../../components/banners/HomeBanner";
import BestDestination from "./BestDestination";
import OffersYouMayLike from "./OffersYouMayLike";
import AboutUs from "./AboutUs";
import BestTraveling from "./BestTraveling";
import { Link, withRouter } from "react-router-dom";
import specialGift from "../../assets/images/special-gift.png";
import { scrollToTopSmooth } from "../../util";
import * as userAction from "../../actions/user-action-type";
import { connect } from "react-redux";
import Kid from "./Kid";
import Family from "./Kid/Family";
import Adventure from "./Kid/Adventure";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import ContentLoader from "react-content-loader";
// import { Oval } from "react-loader-spinner";

// Full-screen loader component
const FullScreenLoader = () => (
  <div
    style={{
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(255, 255, 255, 0.98)",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 9999,
      backdropFilter: "blur(5px)",
    }}
  >
    {/* <Oval
      height={80}
      width={80}
      color="#d4a574"
      secondaryColor="#f5e6d3"
      strokeWidth={4}
      strokeWidthSecondary={4}
    /> */}
    <p
      style={{
        marginTop: "20px",
        fontSize: "18px",
        color: "#333",
        fontWeight: "500",
        letterSpacing: "0.5px",
      }}
    >
      Loading...
    </p>
  </div>
);

function Home(props) {
  // const t = useTranslation()
  document.title = "Discover Shurooq";
  localStorage.setItem("pathname", "/");
  const {
    getSliderDataStatus,
    getHomeData,
    homeData,
    sliderData,
    getDestinationDataStatus,
    destinationData,
    getSliderData,
    getDestinationData,
    settingData,
    getSettingData,
    getAllHomePageData,
    getAllHomePageDataStatus,
  } = props;

  useEffect(() => {
    window.scrollTo({ behavior: "smooth", top: 0 });

    // Use the combined API call for faster loading
    getAllHomePageData();
    // ReactPixel.track('ViewContent', {
    //   content_name: 'Homepage Visit',
    // })
  }, [getAllHomePageData]);

  // Show full-screen loader while data is loading
  if (
    getAllHomePageDataStatus === "requested" ||
    !destinationData ||
    destinationData.length === 0
  ) {
    return <FullScreenLoader />;
  }

  return (
    <>
      <HomeBanner data={destinationData} homeData={settingData} />
      <BestDestination
        status={getDestinationDataStatus}
        data={destinationData}
        // homeData={homeData}
      />

      <section className="text-center spendwinbanner">
        <a
          href="/F&B"
          target="_blank"
          rel="noopener noreferrer"
          // onClick={scrollToTopSmooth}
        >
          {/* static image */}
          {settingData?.spend_win_image ? (
            <LazyLoadImage
              src={`https://api.discovershurooq.ae/cdn-cgi/image/width=900,quality=85,format=auto/files/${settingData?.spend_win_image}`}
              alt="Spend and Win"
              className="w-100 spendwinhomeimg"
              effect="blur"
              style={{
                maxWidth: 900,
              }}
              placeholderSrc={`https://api.discovershurooq.ae/cdn-cgi/image/width=50,quality=50,format=auto/files/${settingData?.spend_win_image}`}
            />
          ) : (
            <div></div>
          )}
        </a>
      </section>

      <section>
        {settingData?.tag1 === "" ? (
          <div></div>
        ) : (
          <Family
            slug={settingData?.tag1}
            header={settingData?.tag1_heading}
            tagtitle={settingData?.tag1_description}
          />
        )}
        {settingData?.tag2 === "" ? (
          <div></div>
        ) : (
          <Adventure
            slug={settingData?.tag2}
            header={settingData?.tag2_heading}
            tagtitle={settingData?.tag2_description}
          />
        )}
        {settingData?.tag3 === "" ? (
          <div></div>
        ) : (
          <Kid
            slug={settingData?.tag3}
            header={settingData?.tag3_heading}
            tagtitle={settingData?.tag3_description}
          />
        )}
      </section>

      {settingData?.display_vouchers === 1 && (
        <OffersYouMayLike data={homeData.voucherData} />
      )}
      {settingData?.display_about_us === 1 && <AboutUs />}
      {settingData?.display_top_experience === 1 && <BestTraveling />}
    </>
  );
}

const mapStateToProps = ({
  user: {
    homeData,
    getSliderDataStatus,
    getDestinationDataStatus,
    sliderData,
    destinationData,
    settingData,
    getAllHomePageDataStatus,
  },
}) => ({
  homeData,
  getSliderDataStatus,
  getDestinationDataStatus,
  sliderData,
  destinationData,
  settingData,
  getAllHomePageDataStatus,
});

const mapDispatchToProps = {
  getAllHomePageData: userAction.getAllHomePageData,
  getSliderData: userAction.getSliderData,
  getDestinationData: userAction.getDestinationData,
  getHomeData: userAction.getHomeData,
  getProfileDetails: userAction.getProfileDetails,
  getSettingData: userAction.getSettingData,
};
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Home));
